export type TimerFormat = 'HH:MM:SS' | 'Dd HH:MM';

function pad(value: number): string {
  return String(value).padStart(2, '0');
}

/**
 * Renders a non-negative duration in seconds for `ElapsedTimer`/`CountdownTimer`.
 *
 * `HH:MM:SS` never rolls hours into a day digit — a multi-day elapsed timer just keeps counting
 * past 24 (e.g. `27:03:10`), the same convention a stopwatch uses. `Dd HH:MM` is the coarser form
 * for a countdown that may span days (a training due date a day or more out), where second-level
 * precision would be noise.
 */
export function formatDuration(totalSeconds: number, format: TimerFormat): string {
  const clamped = Math.max(0, Math.floor(totalSeconds));

  if (format === 'Dd HH:MM') {
    const days = Math.floor(clamped / 86_400);
    const hours = Math.floor((clamped % 86_400) / 3600);
    const minutes = Math.floor((clamped % 3600) / 60);
    return `${days}d ${pad(hours)}:${pad(minutes)}`;
  }

  const hours = Math.floor(clamped / 3600);
  const minutes = Math.floor((clamped % 3600) / 60);
  const seconds = clamped % 60;
  return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
}
